import { isHTTPURL } from "@bracket/chainography";
import type { HTTPURL, Vault } from "@bracket/types";
import { getLogoVariant, type LogoVariant, } from "@utils";
import styled from "styled-components";



export declare type VaultLogoProps = {
	vault: Vault;
	className?: string;
	size?: number;
	width?: string;
	height?: string;
	top?: string;
	variant?: LogoVariant;
	opacity?: number;
};



/**
 * A component that displays a vault logo image
 * 
 * @param {VaultLogoProps} props - The component props
 * @param {Vault} props.vault - The vault object containing logo information
 * @param {string} [props.width] - Css Width to set for the logo
 * @param {string} [props.height] - Css Height to set for the logo
 * @param {string} [props.top] - Css Top to set for the logo
 * @returns {JSX.Element} An image element displaying the vault logo
 */
export const VaultLogo = ({ vault, width, height, variant = "stroked", opacity, top, }: VaultLogoProps) => {

	if(width && height) {
		throw new Error("width and height cannot be used together");
	}

	return (
		<Brace2 className="VaultLogo" $width={width} $height={height} $opacity={opacity} $top={top}>
			{Boolean(vault.logo) && <Imaged src={getLogoVariant({ url: vault.logo, variant: variant, })} alt="logo" $width={width} $height={height} />}
		</Brace2>
	);
};


const Brace = styled.div<{ $width?: string; $height?: string; $opacity?: number; $top?: string; }>`
	position: absolute;
	box-sizing: border-box;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-end;
	padding: 1rem;
	mix-blend-mode: exclusion;
	opacity: ${({ $opacity }) => $opacity || 1};
	// desktop below.
	@media (min-width: 768px) {
		justify-content: center;
	}
`;

const Brace2 = styled.div<{ $width?: string; $height?: string; }>`
	display: flex;
	flex: 1;
	align-items: flex-start;
	justify-content: flex-start;
	height: ${({ $height }) => $height || "auto"};
	// width: ${({ $width }) => $width || "auto"};
	width: 3rem;
	max-width: 3rem;
`;


const ImageLoader = ({ url, }: { url: HTTPURL; }) => {
	return (
		<Frame>
			{/* <Image $src={url} alt="logo" /> */}
			<Imaged src={url} alt="logo" />
		</Frame>
	);
};

const Frame = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	height: 100%;
	width: 100%;
	margin: 0.5rem;
`;


const Image = styled.div<{ $src: HTTPURL; alt?: string; }>`
	position: relative;
	background-image: url(${({ $src, }) => $src});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	width: 40px;
	height: 100%;
	// backdrop-filter: blur(15px) grayscale(50%);
	// filter: invert(1);
	// mix-blend-mode: screen;
	// opacity: 0.75;
	scale: 1;
	// transform: translate(-5px, 18px);
	// filter: drop-shadow(0px 0px 10px #03ff8f);

	// filter:
	// 	drop-shadow( 2px  0px 0px #03ff8f55) 
	// 	drop-shadow(-2px  0px 0px #03ff8f55)
	// 	drop-shadow( 0px  2px 0px #03ff8f55) 
	// 	drop-shadow( 0px -2px 0px #03ff8f55);

	// filter: outline 2px solid #03ff8f;
	// filter: drop-shadow(-2px 4px 4px #03ff8f);
	// filter: drop-shadow(0px 0px 15px black);
`;


const Imaged = styled.img<{ $width?: string; $height?: string; }>`
	width: ${({ $width }) => $width || "auto"};
	height: ${({ $height }) => $height || "auto"};
`;
